import { customElement, property } from 'lit/decorators.js'
import { LitElement, nothing } from 'lit'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { ICON_LIBRARY, IconLibrary, IconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { is } from 'typia'


@customElement('icon-receiver')
export class IconReceiver extends LitElement {
  @inject(ICON_LIBRARY)
  private iconStore!: IconLibrary

  private _iconsByRole: IconsByRole = {}

  get icons() {
    return this._iconsByRole
  }

  @property({ type: Object })
  set icons(value: unknown) {
    if (!is<IconsByRole>(value)) return

    this._iconsByRole = value
    this.iconStore.setIconsByRole(value)
  }

  override render() {
    return nothing
  }
}
